const ZONE_TAG_MAP = {
  '/zonea':              'VDzoneA',
  '/zoneb':              'VDzoneB',
  '/zonec':              'VDzoneC',
  '/zonex':              'VDzoneX',
  '/zonez':              'VDzoneZ',
  '/videowallcontrols':  'VDcontrol',
};

// Maps zone keys (used in the controller grid) to their required tags
const ZONE_KEY_TAG_MAP = {
  zoneA: 'VDzoneA',
  zoneB: 'VDzoneB',
  zoneC: 'VDzoneC',
  zoneX: 'VDzoneX',
  zoneZ: 'VDzoneZ',
};

export const canAccess = (tags, path) => {
  if (!path) return false;
  if (!tags || !Array.isArray(tags)) return false;
  if (tags.includes('VDcontrol')) return true;
  const lowerPath = path.toLowerCase();
  // VDadmin grants access only if user also has at least one zone tag
  if (lowerPath === '/videowallcontrols' && tags.includes('VDadmin')) {
    return tags.some(t => Object.values(ZONE_KEY_TAG_MAP).includes(t));
  }
  const requiredTag = ZONE_TAG_MAP[lowerPath];
  if (!requiredTag) return true;
  return tags.includes(requiredTag);
};

// Returns true if the user can edit a specific zone in the controller
export const canEditZone = (tags, zoneKey) => {
  if (!tags || !Array.isArray(tags)) return false;
  if (tags.includes('VDcontrol')) return true;
  if (!tags.includes('VDadmin')) return false;
  const requiredTag = ZONE_KEY_TAG_MAP[zoneKey];
  return requiredTag ? tags.includes(requiredTag) : false;
};

// Returns the list of zone keys the user is allowed to edit
export const getEditableZones = (tags) => {
  if (!tags || !Array.isArray(tags)) return [];
  if (tags.includes('VDcontrol')) return Object.keys(ZONE_KEY_TAG_MAP);
  if (!tags.includes('VDadmin')) return [];
  return Object.entries(ZONE_KEY_TAG_MAP)
    .filter(([, tag]) => tags.includes(tag))
    .map(([key]) => key);
};

export const firstAllowedRoute = (tags) => {
  if (!tags || !Array.isArray(tags) || tags.length === 0) return '/';
  if (tags.includes('VDcontrol')) return '/videowallcontrols';
  // VDadmin users go to controls only if they also have at least one zone
  if (tags.includes('VDadmin') && tags.some(t => Object.values(ZONE_KEY_TAG_MAP).includes(t))) {
    return '/videowallcontrols';
  }
  for (const [route, tag] of Object.entries(ZONE_TAG_MAP)) {
    if (tag !== 'VDcontrol' && tags.includes(tag)) return route;
  }
  return '/';
};
